var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "wrap"
  }, [_c('div', {
    staticClass: "task-wrap"
  }, [_c('div', {
    staticClass: "task-top"
  }, [_c('div', {
    staticClass: "task-top-left"
  }, [_c('div', [_vm._v("任务")]), _c('RadioGroup', {
    staticStyle: {
      "margin-left": "8px"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "on-change": function ($event) {
        return _vm.loadTask(0);
      }
    },
    model: {
      value: _vm.filterQuery.progress,
      callback: function ($$v) {
        _vm.$set(_vm.filterQuery, "progress", $$v);
      },
      expression: "filterQuery.progress"
    }
  }, [_c('Radio', {
    attrs: {
      "label": "all"
    }
  }, [_vm._v("全部")]), _c('Radio', {
    attrs: {
      "label": "created"
    }
  }, [_vm._v("未完成")])], 1)], 1), _c('Button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function ($event) {
        _vm.showNewTask = true;
      }
    }
  }, [_vm._v("创建")])], 1), _vm.showNewTask ? _c('div', {
    staticClass: "new-task-area"
  }, [_c('div', {
    staticClass: "new-task-input-area"
  }, [_c('div', {
    staticStyle: {
      "width": "120px"
    }
  }, [_vm._v("新任务：")]), _c('Select', {
    staticStyle: {
      "width": "170px"
    },
    attrs: {
      "filterable": ""
    },
    model: {
      value: _vm.newTask.mainResponsible,
      callback: function ($$v) {
        _vm.$set(_vm.newTask, "mainResponsible", $$v);
      },
      expression: "newTask.mainResponsible"
    }
  }, _vm._l(_vm.simpleUserList, function (user) {
    return _c('Option', {
      key: user._id,
      attrs: {
        "value": user._id
      }
    }, [_vm._v(_vm._s(user.name))]);
  }), 1), _c('Input', {
    ref: "input-title",
    attrs: {
      "placeholder": "任务"
    },
    on: {
      "on-enter": _vm.createNewTask
    },
    model: {
      value: _vm.newTask.title,
      callback: function ($$v) {
        _vm.$set(_vm.newTask, "title", $$v);
      },
      expression: "newTask.title"
    }
  }), _c('Input', {
    ref: "input-deadLine",
    staticStyle: {
      "width": "170px"
    },
    attrs: {
      "placeholder": "截止时间"
    },
    on: {
      "on-enter": _vm.createNewTask
    },
    model: {
      value: _vm.newTask.deadLine,
      callback: function ($$v) {
        _vm.$set(_vm.newTask, "deadLine", $$v);
      },
      expression: "newTask.deadLine"
    }
  })], 1), _c('div', {
    staticClass: "new-task-btn-area"
  }, [_c('Button', {
    attrs: {
      "size": "small",
      "type": "primary"
    },
    on: {
      "click": _vm.createNewTask
    }
  }, [_vm._v("保存")]), _c('Button', {
    attrs: {
      "size": "small"
    },
    on: {
      "click": function ($event) {
        _vm.showNewTask = false;
      }
    }
  }, [_vm._v("取消")])], 1)]) : _vm._e(), _vm._l(_vm.taskList, function (task) {
    return _c('div', [_c('TaskBox', {
      attrs: {
        "task": task
      }
    })], 1);
  })], 2), _c('div', {
    staticClass: "comment-wrap"
  }, [_c('div', {
    staticClass: "comment-top"
  }, [_c('div', {
    staticStyle: {
      "margin-bottom": "16px"
    }
  }, [_vm._v("评论")]), _c('Input', {
    staticStyle: {
      "margin-bottom": "16px"
    },
    attrs: {
      "type": "textarea",
      "placeholder": "填写评论..."
    },
    model: {
      value: _vm.newComment.comment,
      callback: function ($$v) {
        _vm.$set(_vm.newComment, "comment", $$v);
      },
      expression: "newComment.comment"
    }
  }), _c('div', {
    staticStyle: {
      "display": "flex",
      "justify-content": "end"
    }
  }, [_c('Button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.createNewComment
    }
  }, [_vm._v("发送")])], 1)], 1), _c('div', {
    staticClass: "comment-list-wrap"
  }, [_c('div', {
    staticClass: "comment-page"
  }, [_c('span', [_vm._v("共" + _vm._s(_vm.commentTotalCounts) + "条")]), _c('Page', {
    staticStyle: {
      "margin-right": "24px"
    },
    attrs: {
      "total": _vm.commentTotalCounts,
      "page-size": _vm.commentLimit,
      "show-total": "",
      "simple": ""
    },
    on: {
      "on-change": _vm.loadComment
    }
  })], 1), _vm._l(_vm.commentList, function (comment) {
    return _c('div', [_c('div', {
      staticClass: "comment-item"
    }, [_c('div', {
      staticClass: "comment-item-top"
    }, [_c('div', {
      staticClass: "comment-createdBy"
    }, [_vm._v(_vm._s(comment.createdBy.name))]), _c('div', {
      staticClass: "comment-createdAt"
    }, [_vm._v(_vm._s(comment.createdAt))])]), _c('div', {
      staticClass: "comment"
    }, [_vm._v(_vm._s(comment.comment))])])]);
  })], 2)])]);

}
var staticRenderFns = []

export { render, staticRenderFns }